import type { ApiEndpointDefinition } from '../api-endpoint.types';

/**
 * Patrol has no routes of its own on the Dealer contract: the list comes from
 * `/events/in-progress` and starting / finishing one uses the `dealer-start-patrol`,
 * `dealer-start-site-check` and `dealer-event-close-patch` operations. See
 * `dealer-openapi.endpoints.ts`.
 */
export const PATROL_ENDPOINTS = {} as const satisfies Record<string, ApiEndpointDefinition>;
